import React from 'react'
import RoboGif from "../../../assets/images/robo.png"

const ThankYou = ({ postFormData }) => {
    return (
        <div className='thank-you-msg-wrapper'>
            <div className='thank-you-content'>
                {
                    postFormData?.filter(component => component.type === "thank_you_form").length ?
                        postFormData?.map((preview, i) => {
                            return (
                                preview?.type === "thank_you_form" &&
                                preview?.value?.map((thank) => {
                                    return (
                                        <>
                                            {
                                                thank?.type === "img" ?
                                                    <img src={thank?.text} alt="Robo Gif" />
                                                    :
                                                    thank?.type === "message" ?
                                                        <p>{thank?.text}</p>
                                                        :
                                                        <></>
                                            }
                                        </>
                                    )
                                })
                            )
                        })
                        :
                        <>
                            <img src={RoboGif} alt="Robo Gif" />
                            <p>Thank you</p>
                            <p>We appreciate your feedback.</p>
                        </>
                }
            </div>
        </div>
    )
}

export default ThankYou
